import Vue from "vue";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

// https://firebase.google.com/docs/web/setup#config-web-app
// https://firebase.google.com/docs/web/setup?authuser=0#configure-to-use-firebase
const fb = firebase.initializeApp({
  apiKey: "AIzaSyCDCgkjrm20SFNLZzAz_RbfsTsa0XxWQK4",
  authDomain: "mdad-app.firebaseapp.com",
  databaseURL: "https://mdad-app.firebaseio.com",
  projectId: "mdad-app",
  storageBucket: "mdad-app.appspot.com",
  messagingSenderId: "1043404638254",
  appId: "1:1043404638254:web:0228e1131193ad2d"
});

fb.provGoogle = new firebase.auth.GoogleAuthProvider();

Vue.use({
  install(Vue) {
    Vue.prototype.$fb = fb;
  }
});

export default fb;
